module.exports = __webpack_public_path__ + "static/media/True_False.6bad7010.jpg";